import React, { useEffect } from 'react'
import { GetAllAddress } from '../../redux/Slices/UserSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'

const UseAllAddressUser = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [alladdressList, setAllAddressList] = useState()
    const { allAddress } = useSelector(state => state.UserReducer)

    // get all address
    const handleGetAllAddress = async () => {
        setLoading(true)
        await dispatch(GetAllAddress())
        setLoading(false)
    }

    // run get all address function
    useEffect(() => {
        handleGetAllAddress()
    }, [])

    // handle the get all address request response
    useEffect(() => {
        if (loading === false) {
            if (allAddress.data)
            setAllAddressList(allAddress.data.data) 
        }
    }, [loading])

    return [alladdressList,loading]
}

export default UseAllAddressUser
